import { Injectable, Inject, InjectionToken } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { BackendError, RestErrorType } from '../../domain/public-api';
import { RestApplicationErrorHandlerService } from '../rest/rest-handlers/rest-application-error-handler.service';
import { SystemStatus, SystemStatusConfiguration } from './system-status.domain';

export const SYSTEM_STATUS_CONFIGURATION = new InjectionToken<SystemStatusConfiguration>('systemStatusConfiguration');

@Injectable({
  providedIn: 'root'
})
export class SystemStatusService {

  readonly onSystemStatusChange: BehaviorSubject<SystemStatus>;

  private readonly systemDownErrorCode: string;
  private systemStatus: SystemStatus;
  private firstStartAfterLogin: boolean;

  constructor(@Inject(SYSTEM_STATUS_CONFIGURATION)
  private configuration: SystemStatusConfiguration,
              private restApplicationErrorHandlerService: RestApplicationErrorHandlerService) {
    this.systemStatus = this.configuration.systemStatus;
    this.firstStartAfterLogin = this.configuration.firstStartAfterLogin;
    this.systemDownErrorCode = this.configuration.systemDownErrorCode;

    this.onSystemStatusChange = new BehaviorSubject<SystemStatus>(this.systemStatus);
    this.restApplicationErrorHandlerService.onCriticalApplicationError.subscribe((error: BackendError): void => {
      if (this.isSystemNotAvailableError(error)) {
        this.onSystemDown();
      }
    });
  }

  isSystemNotAvailableError(error: BackendError): boolean {
    return error.type === RestErrorType.APPLICATION && error.code === this.systemDownErrorCode;
  }

  onSystemDown(): void {
    this.setSystemAvailable(SystemStatus.DOWN);
    this.onSystemStatusChange.next(SystemStatus.DOWN);
  }

  isSystemAvailable(): boolean {
    return this.systemStatus === SystemStatus.AVAILABLE;
  }

  isSystemDown(): boolean {
    return this.systemStatus === SystemStatus.DOWN;
  }

  isMaintenanceMode(): boolean {
    return this.systemStatus === SystemStatus.MAINTENANCE;
  }

  isHighLoadMode(): boolean {
    return this.systemStatus === SystemStatus.HIGH_LOAD;
  }

  setSystemAvailable(systemAvailable: SystemStatus): void {
    this.systemStatus = systemAvailable;
  }

  isFirstStartAfterLogin(): boolean {
    return this.firstStartAfterLogin;
  }

  setFirstStartAfterLogin(firstStartAfterLogin: boolean): void {
    this.firstStartAfterLogin = firstStartAfterLogin;
  }

}
